<template>
    <!-- {{ text }} -->
    <label v-if="route === 'boardView' || text !== 'Checklist'" class="flex flex-nowrap" :class="labelClass">
        <span
            :class="[
                'badge flex flex-nowrap',
                classes,
                type === 'filterLabel' ? 'filter-badge' : 'badge',
                disableLabel ? 'disable-filter-badge' : 'filter-badge',
                classes,
                isCompressed ? 'compressed' : '',
                isStep ? 'step' : '',
                icon ? '!rounded-[2px_0px_0px_2px]' : 'rounded-sm',
            ]"
            :style="{ backgroundColor: classes }"
            @click="appLabelClick"
        >
            <span
                v-if="text === 'certificate' && labelObject.certificate_icon && route !== 'boardView'"
                class="step_title dark:text-white"
                :class="[isView ? 'whitespace-nowrap' : 'white-space: normal']"
            >
                <fa :icon="['fas', labelObject.certificate_icon]" />
            </span>
            <span
                v-else
                class="step_title dark:text-white"
                :class="[isView ? 'whitespace-nowrap' : 'white-space: normal;']"
            >
                {{ count !== 0 ? count : "" }} {{ text }}
            </span>

            <span v-if="isRemovable" class="text-xs text-white ml-2" @click="removeLabel()">
                <fa :icon="['fas', 'xmark']" />
            </span>
        </span>
        <span
            v-if="icon !== 0"
            class="badgeicon"
            :class="icon === 3 ? '!p-[6px]' : ''"
            :style="{
                backgroundColor: icon === 3 ? '#00EBB4' : icon === 2 ? '#FFAA00' : icon === 1 ? '#FF4650' : '',
            }">
            <fa :icon="icon === 3 ? ['fas', 'check'] : ['fas', 'exclamation']" />
        </span>
        <span
            v-else-if="text === 'certificate' && route === 'boardView'"
            class="badgeicon"
            :style="{ backgroundColor: '#FFAA00' }"
        >
            <fa :icon="['fas', 'exclamation']" />
        </span>
    </label>

    <div
        v-if="text === 'Checklist' && route === 'checklistView'"
        class="checkPoint text-white px-2 h-[1.25rem] flex flex-nowrap items-center gap-1 text-xs rounded-[0.125rem]"
        :style="{ background: '#FFB775' }"
    >
        <fa :icon="['fal', 'list-check']" />
        {{ labelObject.checked }}/{{ labelObject.count }}
    </div>
</template>

<script setup>
const emit = defineEmits(["appLabelClick", "removeLabelClick"]);
const props = defineProps({
    text: {
        type: String,
        default: "",
    },
    count: {
        type: String,
        default: "",
    },
    isRemovable: {
        type: Boolean,
        default: false,
    },
    secondText: {
        type: String,
        default: "",
    },
    classes: {
        type: String,
        default: "",
    },
    labelClass: {
        type: String,
        default: "",
    },
    type: {
        type: String,
        default: "",
    },
    isCompressed: {
        type: Boolean,
        default: false,
    },
    isStep: {
        type: Boolean,
        default: false,
    },
    secondClass: {
        type: Boolean,
        default: false,
    },
    isView: {
        type: Boolean,
        default: false,
    },
    icon: {
        type: Number,
        default: 0,
    },
    disableLabel: {
        type: Boolean,
        default: false,
    },
    route: {
        type: String,
        default: null,
    },
    labelObject: {
        type: Object,
        default: () => {},
    },
    labelId: {
        type: String,
        default: null,
    }
});

const check_color = (c) => {
    if (c.startsWith("#")) {
        return `!bg-[${c}]`;
    } else {
        return c;
    }
};

const removeLabel = () => {
    sessionStorage.setItem("addLabelClicked", true);
    emit("removeLabelClick", props.labelObject);
};
const appLabelClick = () => {
    sessionStorage.setItem("addLabelClicked", true);
    emit("appLabelClick");
};
</script>

<style scoped>
.badge {
    @apply px-2 h-[20px] leading-[14.52px] text-xs inline-flex text-white dark:text-black-900 font-normal items-center justify-center cursor-pointer;
}
.badgeicon {
    @apply h-[20px] p-[10px] inline-flex text-xs items-center justify-center leading-[14.52px] text-center !text-white rounded-[0px_2px_2px_0px];
    /* background-color: #FFAA00; */
}
.filter-badge {
    @apply h-5 px-2 py-[3px] text-white dark:text-black-900 rounded-sm text-xs font-normal items-center justify-center cursor-pointer;
    transition: all 0.5s ease;
}
.disable-filter-badge {
    @apply h-5 px-2 py-[3px] text-[#BAC4CD] dark:text-black-900 rounded-sm text-xs font-normal items-center justify-center cursor-pointer;
    transition: all 0.5s ease;
}
.badge.default {
    @apply bg-gray-300;
}
.badge.red {
    @apply bg-red-400;
}
.badge.gray {
    @apply bg-[#DDE3E4];
}
.badge.orange {
    @apply bg-orange-500;
}
.badge.green {
    @apply bg-green-500;
}
.badge.blue {
    @apply bg-blue-500;
}
.badge.pink {
    @apply bg-pink-500;
}
.badge.purple {
    @apply bg-purple-500;
}
.badge.turquoise {
    @apply bg-turquoise-500;
}
.badge.compressed {
    @apply w-6 h-2;
}
.badge.step {
    @apply bg-gray-150 pl-0 dark:bg-dm-palegrey dark:text-dm-white text-black-900;
}
.badge.brown {
    @apply bg-brown-500;
}
.badge.yellow {
    background-color: #ff0;
    color: black;
}
.badge.black {
    @apply bg-black-900 text-white;
}
.step .step_title {
    @apply bg-black-500 text-white px-2.5 rounded-l-full dark:bg-dm-darkgrey dark:text-dm-white;
}
.step span:last-of-type {
    @apply ltr:pl-2.5 rtl:pr-2.5;
}
.stepLabel {
    @apply text-dark-modal dark:text-white;
}
/* we will explain what these classes do next! */
.v-enter-active {
    transition: opacity 0.5s ease;
}
.v-leave-active {
    transition: opacity 0.4s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
